<template>
  <v-menu
    :close-on-content-click="false"
    left
    offset-x
  >
    <template v-slot:activator="{on, attrs}">
      <v-btn
        fab
        depressed
        color="primary"
        v-bind="attrs"
        width="32"
        height="32"
        v-on="on"
      >
        <span>{{ $currentUser.name[0] }}</span>
      </v-btn>
      <v-list-item-content
        class="ml-3"
        v-bind="attrs"
        v-on="on"
      >
        <v-list-item-title>
          {{ $currentUser.shortName }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <v-card width="320">
      <v-list class="dialogBackground">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ $currentUser.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ $currentUser.role }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="!$currentUser.anyCargoType">
              {{ $currentUser.cargoTypeName }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-spacer />
          <v-btn
            color="primary"
            @click="$router.push('/login')"
          >
            Выход
          </v-btn>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <v-switch
            v-model="darkSwitch"
            dense
            label="Тёмная тема"
          />
        </v-list-item>

        <v-list-item>
          <v-switch
            v-model="compactMenuSwitch"
            dense
            label="Сворачивать меню"
          />
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  computed: {
    darkSwitch: {
      get() {
        return this.$store.state.settings.dark === true
      },
      set(val) {
        this.$store.dispatch("settings/setDark", val)
      }
    },

    compactMenuSwitch: {
      get() {
        return this.$store.state.settings.compactMenu === true
      },
      set(val) {
        this.$store.dispatch("settings/setCompactMenu", val)
      }
    },
  }
}
</script>
